<template>
<div class="accountAuthView" v-if="show">
    <el-alert v-if="verifystatus === '0'" title="您未进行认证，请进行个人或企业认证即可获得更多权益" type="warning" show-icon  :closable="false"></el-alert>
    <el-alert v-if="verifystatus === '1' && hosttype === '1'" title="您提交企业认证的资料我们正在审核中，请耐心等待。" type="warning" show-icon  :closable="false"></el-alert>
    <el-alert v-if="verifystatus === '1' && hosttype === '2'" title="您提交个人认证的资料我们正在审核中，请耐心等待。" type="warning" show-icon  :closable="false"></el-alert>
    <el-alert v-if="verifystatus === '10' && hosttype === '1'" title="恭喜，您提交的企业认证资料已经通过了我们的审核！" type="success" show-icon></el-alert>
    <el-alert v-if="verifystatus === '10' && hosttype === '2'" title="恭喜，您提交的个人认证资料已经通过了我们的审核！" type="success" show-icon></el-alert>
    <el-alert v-if="verifystatus === '11'" :title="'当前的认证信息被驳回，驳回原因：'+authmemo" type="error" show-icon :closable="false"></el-alert>
    <p class="title marginTop20">认证类型</p>
    <div class="choiceAuthWay">
        <div class="companyAuth" v-if="verifystatus == '11' || verifystatus == '0' || ((verifystatus == '1' || verifystatus == '10') && hosttype == '1')">
            <img :src="require('@/common/images/other/company@2x.png')" alt="">
            <p class="name">企业</p>
            <div class="detail">适合企业及机构 <br> 加蓝V标识</div>
            <el-button type="primary" @click="choiceAuth('0')" v-if="verifystatus == '11' || verifystatus == '0'">选择</el-button>
            <el-button type="primary" @click="choiceAuth('0')" v-if="verifystatus == '10'" :disabled="true">已认证</el-button>
            <el-button type="primary" @click="choiceAuth('0')" v-if="verifystatus == '1'" :disabled="true">认证中</el-button>
            <div class="authIng"><img v-if="verifystatus === '1'" :src="require('@/common/images/other/authIng.png')" alt="审核中"></div>
            <div class="authEd"><img v-if="verifystatus === '10'" :src="require('@/common/images/other/pass.png')" alt="已认证"></div>
        </div>
        <div class="personalAuth" v-if="verifystatus == '11' || verifystatus == '0' || ((verifystatus == '1' || verifystatus == '10') && hosttype == '2')">
            <img :src="require('@/common/images/other/personal@2x.png')" alt="">
            <p class="name">个人</p>
            <div class="detail">适合个人 <br> 加橙V标识</div>
            <!-- <el-button type="primary" @click="choiceAuth('1')" :disabled="(verifystatus !== '11' || verifystatus !== '0')">{{status}}</el-button> -->
            <el-button type="primary" @click="choiceAuth('1')" v-if="verifystatus == '11' || verifystatus == '0'">选择</el-button>
            <el-button type="primary" @click="choiceAuth('1')" v-if="verifystatus == '10'" :disabled="true">已认证</el-button>
            <el-button type="primary" @click="choiceAuth('1')" v-if="verifystatus == '1'" :disabled="true">认证中</el-button>
            <div class="authIng"><img v-if="verifystatus === '1'" :src="require('@/common/images/other/authIng.png')" alt="审核中"></div>
            <div class="authEd"><img v-if="verifystatus === '10'" :src="require('@/common/images/other/pass.png')" alt="已认证"></div>
        </div>
    </div>
    <p class="title marginTop20">获得权益</p>
    <div class="equity_warp">
        <div v-for="(item,index) in equityList" :key="index">
            <img :src="item.icon" alt="">
            <h4 class="marginTop20">{{item.title}}</h4>
            <p>{{item.explain}}</p>
            <p>{{item.tip}}</p>
        </div>
    </div>
    <p class="title marginTop20">实名认证审核及费用</p>
    <div class="question_box">
        <div class="marginTop15"><img :src="icon0" alt=""><span>个人认证是那些人可以申请</span></div>
        <p class="marginTop15">仅个人申请</p>
        <div class="marginTop15"><img :src="icon0" alt=""><span>企业认证是那些人可以申请</span></div>
        <p class="marginTop15">供企业或组织申请</p>
        <div class="marginTop15"><img :src="icon0" alt=""><span>实名认证审核需要多久？</span></div>
        <p class="marginTop15">资料提交后，3~7个工作日即可完成审核；届时可能会有电话回访，请留意来电。</p>
        <div class="marginTop15"><img :src="icon0" alt=""><span>认证需要收费吗？</span></div>
        <p class="marginTop15">认证是免费的。</p>
    </div>
</div>
</template>

<script>
import PersonalAuthView from 'views/accountMgt/accountAuth/PersonalAuthView'
import CompanyAuthView from 'views/accountMgt/accountAuth/CompanyAuthView'
import {authMsgQuery} from '@/api/accountApi'
export default {
    name: 'accountAuthView',
    data() {
        return {
            activeName: 'first',
            verifystatus: '0',
            authmemo: '',
            hosttype: '',
            icon0: require('@/common/images/other/icon0@2x.png'),
            equityList: [
                {title: '加V标识', icon: require('@/common/images/other/icon1@2x.png'), explain: '防止假冒，增加可信度', tip: ''},
                {title: '内容优先审核', icon: require('@/common/images/other/icon2@2x.png'), explain: '工作时间4小时完成审核 ', tip: '(非认证用户为24小时)'},
                {title: '刷新内容排名', icon: require('@/common/images/other/icon3@2x.png'), explain: '1次/天，内容排名靠前', tip: ''},
                {title: '可申请强力推荐', icon: require('@/common/images/other/icon4@2x.png'), explain: '仅限认证用户', tip: '(可联系运营部申请)'},
                {title: '一键通知粉丝', icon: require('@/common/images/other/icon5@2x.png'), explain: '快速向粉丝宣传内容', tip: ''},
                {title: '短信、邮件群发', icon: require('@/common/images/other/icon6@2x.png'), explain: '定向精准营销', tip: ''},
                {title: '一键通知粉丝', icon: require('@/common/images/other/icon7@2x.png'), explain: '快速向粉丝宣传内容', tip: ''}
            ],
            show: false
        }
    },
    created() {
        this.authMsgQuery()
    },
    mounted() {
    },
    methods: {
        authMsgQuery() {
            authMsgQuery({
                data: {},
                success: data => {
                    this.verifystatus = data.data.verifystatus
                    this.hosttype = data.data.hosttype
                    this.authmemo = data.data.authmemo
                    this.show = true
                    // this.authMsg = data.data.authdesp
                    console.log(data)
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        handleClick(tab, event) {
            console.log(tab, event)
        },
        choiceAuth(v) {
            if (v === '1') {
                this.$router.push({name: 'PersonalAuth'})
            } else if (v === '0') {
                this.$router.push({name: 'CompanyAuth'})
            }
        }
    },
    filters: {},
    watch: {},
    computed: {
        status() {
            if (this.verifystatus === '0') {
                return '选择'
            } else if (this.verifystatus === '1') {
                return '认证中'
            } else if (this.verifystatus === '10') {
                return '已认证'
            } else {
                return '选择'
            }
        }
    },
    components: {
        PersonalAuthView,
        CompanyAuthView
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.accountAuthView {
    .marginTop20{
        margin-top: 20px;
    }
    .choiceAuthWay{
        display: flex;
        justify-content: flex-start;
        padding-top: 20px;
        .personalAuth,.companyAuth{
            width: 180px;
            height: 244px;
            border: 1px solid #e6f1fc;
            box-sizing: border-box;
            padding: 30px 0 20px;
            text-align: center;
            border-radius: 4px;
            position: relative;
            .authIng,.authEd{
                position: absolute;
                top: 0;
                left: 0;
            }
            .name{
                line-height: 40px;
                font-size: 16px;
                font-weight: 500;
            }
            .detail{
                line-height: 18px;
                font-size: 12px;
            }
            img{
                width: 60px;
                height: 60px;
            }
            .el-button{
                margin-top: 20px;
            }
        }
        .personalAuth{
            color: #E6A23C;
        }
        .companyAuth{
            margin-right: 52px;
            color: #409EFF;
        }
        .personalAuth:hover,.companyAuth:hover{
            box-shadow:4px 4px 20px 0px #0015291a;
            cursor: pointer;
        }
    }
    .marginTop15{
        margin-top: 15px;
    }
    .title{
        border-left: 2px solid #409EFF;
        padding-left: 10px;
        font-size: 16px;
        font-weight: bold;
        color: #303133;
    }
    .equity_warp{
        padding: 0px 10px 10px 10px;
        display: flex;
        flex-wrap: wrap;
        &>div{
            width: 180px;
            height: 204px;
            margin-top: 20px;
            margin-right: 50px;
            // cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;
            img{
                width: 60px;
                height: 60px;
                margin-top: 30px;
            }
            h4{
                font-size:16px;
                color: #303133;
                font-weight: bold;
                margin-bottom: 10px;
            }
            p{
                width: 128px;
                font-size: 12px;
                color: #909399;
                line-height:18px;
                text-align: center;
            }
        }
        &>div:hover{
            box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
            -webkit-box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
            -ms-box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
            -o-box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
            -moz-box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
        }
    }
    .question_box{
        padding-top: 5px;
        &>div{
            padding-left: 10px;
            display: flex;
            align-items: center;
            img{
                width: 20px;
                height: 20px;
                margin-right: 10px;
            }
            span{
                 font-size: 16px;
                font-weight: bold;
                color: #409EFF;
            }
        }
        &>p{
            padding-left: 40px;
            color: #606266;
        }
    }
    .btn_box{
        margin-top: 40px;
        margin-bottom: 20px;
    }

}
</style>
